import { AlertStatus } from '@/entities/alert-status';
import { cls } from '@/utils/cls';

export type BadgeMinAlertStatusProps = {
  minAlertStatus: AlertStatus;
};

export function BadgeMinAlertStatus({
  minAlertStatus,
}: BadgeMinAlertStatusProps) {
  return (
    <div className="flex items-center gap-3">
      <div
        className={cls(
          'h-4 w-4 flex-shrink-0 rounded-md',
          colors[minAlertStatus],
        )}
      />
      {labels[minAlertStatus]}
    </div>
  );
}

const colors: Record<AlertStatus, string> = {
  OK: 'bg-emerald-400',
  Info: 'bg-zinc-400',
  Warning: 'bg-yellow-400',
  Tripped: 'bg-yellow-400',
  Critical: 'bg-red-400',
};

const labels: Record<AlertStatus, string> = {
  OK: 'All alerts (OK → Critical)',
  Info: 'All alerts (Info → Critical)',
  Warning: 'Warning and higher',
  Tripped: 'Tripped and higher',
  Critical: 'Critical only',
};
